import React, { Component } from 'react';

import './PageTitle.css';

const PageTitle = props => {
    const { icon, title, subtitle, tag, actions, children } = props;

    const Tag           = tag || 'h3';
    const iconClassname = "pt-1 fa fa-" + icon;

    return (
        <Tag className="PageTitle">
            <div className="clearfix" style={{ padding: '.5rem' }}>
                <div className="float-left d-flex items-start gap-2">
                    <i className={ iconClassname }></i>
                    <div className="d-flex flex-column items-start">
                        { title }
                        <span className="text-lg">{ subtitle }</span>
                    </div>
                </div>
                <div className="float-right">
                    { actions}
                </div>
            </div>
            { children }
        </Tag>
    );
}

export default PageTitle;
